/*
  Keeps Add to cart in a busy state from press until UpCart reports the cart loaded.
  See snippets/pdp-atc-loading.liquid for why this exists. Styles live in
  pdp-styling.css.
*/
(function () {
  if (window.__koiAtcLoading) return;
  window.__koiAtcLoading = true;

  /*
    Hard ceiling. A button stuck spinning is worse than no spinner, so this always
    wins - and 2s is short enough that a slow cart reads as a finished button rather
    than a hung one.
  */
  var MAX_WAIT = 2000;

  /* Hiding the label hides it from assistive tech too, so the button needs a name. */
  var BUSY_LABEL = 'Adding to cart';

  var busyBtn = null;
  var ceiling = null;

  function clear() {
    if (busyBtn) {
      busyBtn.classList.remove('pdp-atc-busy');
      busyBtn.removeAttribute('aria-busy');
      var prior = busyBtn.getAttribute('data-atc-label');
      if (prior) {
        busyBtn.setAttribute('aria-label', prior);
      } else {
        busyBtn.removeAttribute('aria-label');
      }
      busyBtn.removeAttribute('data-atc-label');
      busyBtn = null;
    }
    if (ceiling) {
      clearTimeout(ceiling);
      ceiling = null;
    }
  }

  /*
    Some buttons carry .add_to_cart_button but only scroll to the real one - the
    sticky bar does this whenever the block is set to link through instead of adding.
    Spinning those would be feedback for something that never happens.
  */
  function isScrollOnly(btn) {
    var attrs = btn.attributes;
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].name.indexOf('click') !== -1 &&
          attrs[i].value.indexOf('scrollToAtcBtn') !== -1) return true;
    }
    return false;
  }

  function mark(btn) {
    clear();
    btn.classList.add('pdp-atc-busy');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('data-atc-label', btn.getAttribute('aria-label') || '');
    btn.setAttribute('aria-label', BUSY_LABEL);
    busyBtn = btn;
    ceiling = setTimeout(clear, MAX_WAIT);
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('.add_to_cart_button, .x-atc-button-sticky');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (isScrollOnly(btn)) return;
      mark(btn);
    },
    true
  );

  /*
    Chained rather than assigned, because theme.js hangs its deferred open-cart logic
    off this same callback. Overwriting it would break that.
  */
  var previous = window.upcartOnCartLoaded;
  window.upcartOnCartLoaded = function (cart) {
    if (typeof previous === 'function') {
      try { previous(cart); } catch (e) {}
    }
    clear();
  };

  window.addEventListener('pageshow', clear);
})();
